import React, { Component } from 'react';
import './searchSelect.css';
import Select from 'react-select';

export class SearchSelect extends Component {
  render() {
    return (
      <Select
        clearable={false}
        options={this.props.options}
        onChange={this.props.onChange}
        value={this.props.value}
        placeholder={this.props.placeholder}
        style={{ width: '100%' }}
        className={this.props.className}
        getOptionLabel={(e) => (
          <>
            {e.icon ? e.icon : ''}
            {e.label}
          </>
        )}
      />
    );
  }
}
